import { reportActionTypes } from '../actions/reportActions';

const ReportReducers = (state = {}, action) => {
  switch (action.type) {
  case reportActionTypes.GET_REPORTS.LOADING: {
    const { getReportsLoading } = action;
    return {
      ...state,
      getReportsLoading,
    };
  }
  case reportActionTypes.GET_DOWNLOAD_REPORTS.LOADING: {
    const { getDownloadReportsLoading } = action;
    return {
      ...state,
      getDownloadReportsLoading,
    };
  }

  case reportActionTypes.GET_REPORTS.SUCCESS: {
    const { reportData: { reportData, reportType} } = action;
    if (reportType === 'purchase_by_vendor') {
      return { ...state, purchaseByVendor: reportData };
    }
    if (reportType === 'purchase_by_product') {
      return { ...state, purchaseByProduct: reportData };
    }
    if (reportType === 'purchase_ledger') {
      return { ...state, purchaseLedger: reportData };
    }
    if (reportType === 'inventory_summary') {
      return { ...state, inventorySummary: reportData };
    }
    if (reportType === 'inventory_adjustment') {
      return { ...state, inventoryAdjustment: reportData };
    }
    if (reportType === 'stock_transfer_report') {
      return { ...state, stockTransfer: reportData };
    }
    if (reportType === 'inventory_report') {
      return { ...state, inventoryReport: reportData };
    }
    if (reportType === 'stock_inward_report') {
      return { ...state, stockInward: reportData };
    }
    if (reportType === 'stock_outward_report') {
      return { ...state, stockOutward: reportData };
    }
    if (reportType === 'sales_ledger') {
      return { ...state, salesLedger: reportData };
    }
    if (reportType === 'sales_by_customer') {
      return { ...state, salesByCustomer: reportData };
    }
    if (reportType === 'sales_by_product') {
      return { ...state, salesByProduct: reportData };
    }
    if (reportType === 'mo_report') {
      return { ...state, productionReport: reportData };
    }
    return { ...state };
  }

  case reportActionTypes.GET_PRODUCTION_REPORTS.LOADING: {
    const { getProductionReportsLoading } = action;
    return {
      ...state,
      getProductionReportsLoading,
    };
  }

  case reportActionTypes.GET_PRODUCTION_REPORTS.SUCCESS: {
    const { productionReportData } = action;
    return {
      ...state,
      productionReportData,
    };
  }

  case reportActionTypes.GET_STOCK_AGEING_REPORTS.LOADING: {
    const { getStockAgeingReportsLoading } = action;
    return {
      ...state,
      getStockAgeingReportsLoading,
    };
  }

  case reportActionTypes.GET_STOCK_AGEING_REPORTS.SUCCESS: {
    const { StockAgeingReportData } = action;
    return {
      ...state,
      StockAgeingReportData,
    };
  }

  default: {
    return state;
  }
  }
};
export default ReportReducers;
